<script>
    import Image from "./Image.svelte";
    import Checkbox from "../../Common/Checkbox.svelte";
    import Button from "./Button.svelte";
    import {M} from "../../external";

    export let data;
</script>
<Checkbox bind:data={data.switched} label={M.SWITCH_SIDE}/>
<Image bind:data={data} disable={['link', 'width']}/>
<Button bind:data={data} isCollapsable={true} isCollapsed={true}/>
